import { IconButtonProps, IconButton, Box, Button, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getImagePath } from "../../../util/envFn";

export const HeaderIconButton = ({ children, ...props }: { children: ReactNode } & IconButtonProps) => {
    return (
        <IconButton
            size="small"
            {...props}
            sx={{
                p: 1,
                width: 40,
                height: 40,
                color: 'tf.textLight',
                '&:hover': {
                    backgroundColor: 'action.hover',
                    color: 'tf.textDark'
                },
                ...props.sx
            }}
        >
            {children}
        </IconButton>
    );
};

export const LogoButton = () => {
    const navigate = useNavigate();
    return (
        <Button
            disableRipple
            onClick={() => navigate('/')}
            sx={{
                p: 1,
                minWidth: 0,
                '&:hover': {
                    backgroundColor: 'transparent',
                    transform: 'none'
                }
            }}
        >
            <Stack direction="row" alignItems="center" gap={2} >
                <Box component="img" src={getImagePath('logo/icon.jpeg')} alt="Plamas" sx={{ height: 40 }} />
                <Typography variant="subtitle1">Teenfure Job Portal</Typography>
            </Stack>
        </Button>
    );
};

export const HeaderButton = ({ children, to }: { children: ReactNode, to: string }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const isActive = location.pathname.startsWith(`/${to}`);

    return (
        <Stack alignItems="center" gap={0}>
            <Button
                variant="navTab"
                onClick={() => navigate(to)}
                sx={{
                    py: 0.3,
                    color: isActive ? 'primary.main' : 'inherit',
                }}
            >
                {children}
            </Button>
            <Box sx={{ display: isActive ? 'block' : 'none', backgroundColor: 'primary.main', height: 2, width: .95 }} />
        </Stack>
    );
};


